import React, { memo, useCallback } from 'react';
import { Handle, Position, useReactFlow } from 'reactflow';
import { coreEdgeStyle } from './edges/coreEdgeStyleDef';
import { Box } from '@mui/material';

const EDGE_COLORS = [
  'green',
  'blue',
  'red',
  'purple',
  'orange',
  'yellow',
  '#90EE90',
  '#ADD8E6',
  '#FFC0CB',
  '#E6E6FA',
  '#FFD700',
  '#FFFFE0',
];

interface Props {
  isConnectable: boolean;
  nodeId: string;
  targetName: string;
  style?: React.CSSProperties;
  position: Position;
  setActiveTargetName?: (targetName: string) => void;
  className?: string;
}

const TargetHandle = ({
  isConnectable,
  nodeId,
  targetName,
  style,
  position,
  setActiveTargetName,
  className,
}: Props) => {
  const { setEdges, getEdges } = useReactFlow();
  const handleEdgeColors = useCallback(() => {
    let colorIndex = 0;
    const coloredEdges = getEdges().map(edge => {
      if (edge.target === nodeId && edge.targetHandle === targetName) {
        const updatedEdge = {
          ...edge,
          style: {
            ...edge.style,
            stroke: EDGE_COLORS[colorIndex],
            strokeWidth: 10,
          },
          type: 'coloredEdge',
          markerEnd: coreEdgeStyle.markerEndCustom,

          data: {
            coloredEdge: true,
            coloredFromSource: false,
            coloredFromTarget: true,
          },
        };

        colorIndex = (colorIndex + 1) % EDGE_COLORS.length; // Cycle through colors
        return updatedEdge;
      }
      return {
        ...edge,
        style: {
          ...edge.style,
          stroke: '#6e75ff',
          strokeWidth: 1,
        },
        type: edge.type === 'custom' ? 'custom' : '',
        markerEnd: edge.type === 'custom' ? undefined : coreEdgeStyle.markerEnd,
        data: {
          coloredEdge: false,
        },
      };
    });

    setEdges(coloredEdges);
  }, [getEdges, setEdges, nodeId, targetName]);
  return (
    <Box>
      <Handle
        type='target'
        position={position}
        id={targetName}
        isConnectable={isConnectable}
        style={style}
        className={className}
        onClick={e => {
          e.stopPropagation();
          setActiveTargetName?.(targetName);
          handleEdgeColors();
        }}
      />
    </Box>
  );
};

export default memo(TargetHandle);
